import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
interface PaginationRowProps {
	onPrev?: () => void;
	onNext?: () => void;
	disablePrev?: boolean;
	disableNext?: boolean;
	currentStart?: number;
	currentEnd?: number;
	total?: number;
}
const PaginationRow: React.FC<PaginationRowProps> = ({
	onPrev,
	onNext,
	disablePrev = false,
	disableNext = false,
	currentStart = 1,
	currentEnd = 10,
	total = 0,
}) => {
	return (
		<div className='flex flex-col sm:flex-row items-center justify-between py-2 px-4  rounded-b-xl gap-2'>
			{/* Left side — showing info */}
			<div className='text-sm sm:text-sm text-[#8b8d8f] '>
				Showing {currentStart}-{currentEnd} of {total}
			</div>

			{/* Right side — buttons */}
			<div className='flex items-center bg-white rounded-full shadow-sm border border-gray-200 overflow-hidden w-fit'>
				{/* Previous */}
				<button
					onClick={onPrev}
					disabled={disablePrev}
					className={`flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 border-r border-gray-200 transition
            ${
				disablePrev
					? 'text-gray-300 cursor-not-allowed'
					: 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
			}`}
				>
					<FiChevronLeft size={16} />
				</button>

				{/* Next */}
				<button
					onClick={onNext}
					disabled={disableNext}
					className={`flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 transition
            ${
				disableNext ? 'text-gray-300 cursor-not-allowed' : 'text-gray-800 hover:bg-gray-100'
			}`}
				>
					<FiChevronRight size={16} />
				</button>
			</div>
		</div>
	);
};

export default PaginationRow;
